// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"82db7857","513":"24961993","703":"b46d5f3d","787":"91620040"}[chunkId] + ".chunk.js";
};